import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettings } from './app.settings';
import { CookieService } from 'ngx-cookie-service';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { PagesComponent } from './pages/pages.component';
import { MAT_DATE_LOCALE, MatNativeDateModule, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MomentModule } from 'ngx-moment';
import { LocalizeDatePipe } from './shared/pipes/localize-date.pipe';
import { ConfirmBoxComponent } from './pages/confirm-box/confirm-box.component';
import { NumbersOnlyDirective } from './core/directives/numbers-only.directive';
import { MyRegExDirective } from './core/directives/my-reg-ex.directive';
import { PhoneNumberDirective } from './core/directives/phone-number.directive';
import { ErrorDialogComponent } from './error/error-dialog/error-dialog.component';
import { HttpInterceptorProviders } from './core/interceptors';
import { SignoutBeforeUnloadDirective } from './core/directives/signout-before-unload.directive';
import { UploadProgressComponent } from './pages/upload-progress/upload-progress.component';
import { PrePaymentRequestComponent } from './pages/pre-payment-request/pre-payment-request.component';
import { JoinToPelecrdComponent } from './pages/join-to-pelecrd/join-to-pelecrd.component';
import { BitNotSetComponent } from './pages/bit-not-set/bit-not-set.component';
import { AllPaidOrPendingPaymentComponent } from './pages/all-paid-or-pending-payment/all-paid-or-pending-payment.component';
import { AvailableBalanceDialogComponent } from './pages/available-balance-dialog/available-balance-dialog.component';
import { SendFormDialogComponent } from './dialogs/send-form-dialog/send-form-dialog.component';
import { SendFormAreYouSureDialogComponent } from './dialogs/send-form-are-you-sure-dialog/send-form-are-you-sure-dialog.component';
import { CommonDialogComponent } from './dialogs/common-dialog/common-dialog.component';
import { BrowserStateComponent } from './pages/browser-state/browser-state.component';
import { SelectDepartmentDialogComponent } from './pages/select-department-dialog/select-department-dialog.component';
import { LogPublisherService } from './shared/logService/log-publisher.service';
import { LogService } from './shared/logService/log.service';






// import { DynamicFormComponent } from './dynamic-forms/components/dynamic-form/dynamic-form.component';
// import { DynamicFormQuestionComponent } from './dynamic-forms/components/dynamic-form-question/dynamic-form-question.component';




// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   wheelPropagation: true,
//   suppressScrollX: true               
// };
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};


@NgModule({
    declarations: [
        AppComponent,
        NotFoundComponent,
        ErrorComponent,
        PagesComponent,
        ConfirmBoxComponent,
        ErrorDialogComponent,
        SendFormDialogComponent,
        SignoutBeforeUnloadDirective,
        UploadProgressComponent,
        SelectDepartmentDialogComponent,
        PrePaymentRequestComponent,
        JoinToPelecrdComponent,
        BitNotSetComponent,
        AllPaidOrPendingPaymentComponent,
        AvailableBalanceDialogComponent,
        SendFormDialogComponent,
        SendFormAreYouSureDialogComponent,
        CommonDialogComponent,
        BrowserStateComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SharedModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MomentModule,
        FormsModule,
        ReactiveFormsModule,
        PerfectScrollbarModule
    ],
    providers: [
        AppSettings,
        CookieService,
        LogService,
        LogPublisherService,
        { provide: MAT_DATE_LOCALE, useValue: 'he-IL' },
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        HttpInterceptorProviders
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
